import { debounce } from './debounce'

export const registerNestedMenu = () => {
    if (document.querySelector('.menu-item-has-children')) {
        const menuItemsWithChildren = document.querySelectorAll(
            '.menu-item-has-children > a'
        )

        const addArrowToMenuItem = (item) => {
            const arrowDiv = document.createElement('div')
            arrowDiv.classList.add('sub-menu-arrow')
            item.appendChild(arrowDiv)
        }

        // Handle click only on mobile (hover on desktop)
        const handleMenuItemClick = (item) => {
            const arrow = item.querySelector('.sub-menu-arrow')

            item.addEventListener('click', (e) => {
                if (window.innerWidth < 1024) {
                    e.preventDefault()
                    item.nextElementSibling.classList.toggle('is-open')
                    arrow.classList.toggle('arrow-rotated')
                }
            })
        }

        Array.from(menuItemsWithChildren).forEach((item) => {
            addArrowToMenuItem(item)
            handleMenuItemClick(item)

            window.addEventListener(
                'resize',
                debounce(function (event) {
                    if (window.innerWidth >= 1024) {
                        menuItemsWithChildren.forEach((item) => {
                            item.nextElementSibling.classList.remove('is-open')
                            item.querySelector(
                                '.sub-menu-arrow'
                            ).classList.remove('arrow-rotated')
                        })
                    }
                })
            )
        })
    }
}